export default __webpack_public_path__ + "static/Capsule-Zapier-6151a28f57dc21626640d1ef011c3313.mp4";